import type { VehicleLayout } from './axle-placement';

/** Where the kingpin sits behind a semi-trailer's front, as `kingpin()` in trailer-chassis-meshes.ts draws it. */
const KINGPIN_DEPTH = 0.9;
/** How far ahead of the drive group's middle the fifth wheel sits (truck-meshes.ts). */
const FIFTH_WHEEL_LEAD = 0.2;
/** The space a drawbar trailer's bar spans between the truck's tail and the trailer's front. */
const DRAWBAR_GAP = 1.4;

/**
 * How far behind the truck's centre the trailer it pulls has its own centre, along the length (front toward −z), each vehicle
 * centred on its own origin as `placeVehicle` and `buildVehicle` leave it. A semi-trailer slides back until its kingpin is over
 * the fifth wheel, ahead of the middle of the truck's driven axles; a drawbar trailer rides behind the truck, the bar between.
 */
export function towedOffset(truck: VehicleLayout, trailer: VehicleLayout): number {
  const driven = truck.axles.filter((axle) => axle.role !== 'steer').map((axle) => axle.depth);
  if (trailer.bodyStyle === 'drawbar' || driven.length === 0) return truck.length / 2 + DRAWBAR_GAP + trailer.length / 2;
  const fifthWheel = (driven[0] + driven[driven.length - 1]) / 2 - FIFTH_WHEEL_LEAD;
  return fifthWheel - truck.length / 2 - KINGPIN_DEPTH + trailer.length / 2;
}
